import * as React from 'react'
import styled from 'styled-components'

import { styles as S } from '@bob/design-system'

import { RichText } from './RichText'
import { Hyperlink } from './Hyperlink'

export type IllustrationProps = {
  __typename: 'Illustration'
  sys: { id: string }
  image: {
    url: string
    width: number | null
    height: number | null
    title: string | null
    description: string | null
  }
  align: 'none' | 'left' | 'right'
  link: string | null
  content: {
    json: any
  } | null
}

export function Illustration(illustration: IllustrationProps): React.ReactElement<IllustrationProps> {
  const Wrapper = illustration.content === null ? React.Fragment : FloatWrapper
  return (
    <HyperlinkWrapper uri={illustration.link}>
      <Wrapper>
        <S.wysiwyg.Figure $float={illustration.align}>
          <S.wysiwyg.Image src={illustration.image.url} alt={illustration.image.title ?? undefined} />
          {illustration.image.description && (
            <S.wysiwyg.Caption
              dangerouslySetInnerHTML={{
                __html: illustration.image.description,
              }}
            />
          )}
        </S.wysiwyg.Figure>
        {illustration.content && <RichText document={illustration.content.json} />}
      </Wrapper>
    </HyperlinkWrapper>
  )
}

function HyperlinkWrapper(props: { children: React.ReactNode; uri: string | null }): React.ReactElement {
  if (props.uri === null) {
    return <>{props.children}</>
  }

  return <Hyperlink uri={props.uri}>{props.children}</Hyperlink>
}

const FloatWrapper = styled.div`
  &::after {
    content: '';
    display: block;
    clear: both;
  }
`
